export function getAll() {
  return [
    {
      value: 1,
      name: "June1Sale",
      text: "六月初一銷貨單",
    },
    {
      value: 2,
      name: "June1Member",
      text: "六月初一會員",
    },
    {
      value: 3,
      name: "LingYuehDepartment",
      text: "凌越部門",
    },
    {
      value: 4,
      name: "LingYuehEmployee",
      text: "凌越員工",
    },
    {
      value: 5,
      name: "LingYuehCustomer",
      text: "凌越客戶",
    },
    {
      value: 6,
      name: "LingYuehWarehouse",
      text: "凌越倉庫",
    },
    {
      value: 7,
      name: "LingYuehSale",
      text: "凌越銷售",
    },
    {
      value: 8,
      name: "LingYuehFood",
      text: "凌越商品",
    },
    {
      value: 9,
      name: "LingYuehStockTransfer",
      text: "凌越調撥",
    },
    {
      value: 10,
      name: "DigiwinCustomer",
      text: "鼎新客戶",
    },
    {
      value: 11,
      name: "DigiwinSale",
      text: "鼎新銷售",
    },
    {
      value: 12,
      name: "ElecInvoice",
      text: "電子發票",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
